"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const errors_1 = require("@ledgerhq/errors");
const logic_1 = require("./logic");
const getTransactionStatus = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    const errors = {};
    const warnings = {};
    const useAllAmount = !!t.useAllAmount;
    if (!t.fees) {
        errors.fees = new errors_1.FeeNotLoaded();
    }
    const estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
    const totalSpent = useAllAmount ? a.balance : new bignumber_js_1.BigNumber(t.amount).plus(estimatedFees);
    const amount = useAllAmount ? a.balance.minus(estimatedFees) : new bignumber_js_1.BigNumber(t.amount);
    if (totalSpent.gt(a.balance)) {
        errors.amount = new errors_1.NotEnoughBalance();
    }
    if (!amount.gt(0)) {
        errors.amount = new errors_1.AmountRequired();
    }
    if (!t.recipient) {
        errors.recipient = new errors_1.RecipientRequired();
    }
    else if (!(0, logic_1.isValidAddress)(t.recipient, a.currency.id)) {
        errors.recipient = new errors_1.InvalidAddress();
    }
    else if (t.mode === "send" && a.freshAddress === t.recipient) {
        errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
    }
    return Promise.resolve({
        errors,
        warnings,
        estimatedFees,
        amount,
        totalSpent,
    });
});
exports.default = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map